import { CButton, CCard, CCardBody, CCardFooter } from "@coreui/react";
import SubmitButton from "components/SubmitButton";
import { useWarningModal } from "features/modal";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { IoIosWarning } from "react-icons/io";

export const WarningModal = () => {
  const { getDispacthedProps, closeWarning, isModalOpen } = useWarningModal();
  const {
    func,
    onCancel,
    onConfirm,
    text,
    duration = 0,
  } = getDispacthedProps();

  const [countdown, setCountdown] = useState(duration);
  const isValidToContinue = countdown <= 0;
  const modalFlag = isModalOpen();

  useEffect(() => {
    if (modalFlag) {
      setCountdown(duration);

      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
          }

          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    }
  }, [modalFlag]);

  const element = document.getElementsByClassName("c-app c-default-layout")[0];

  return (
    <>
      {element
        ? createPortal(
            <>
              {modalFlag ? (
                <>
                  <div
                    className="warning-modal-backdrop"
                    onClick={() => {
                      if (onCancel) onCancel();
                      closeWarning();
                    }}
                  ></div>
                  <div className="p-2 tw-top-1/2 tw-left-1/2 tw-z-[99999] -tw-translate-x-1/2 -tw-translate-y-1/2 tw-absolute">
                    <CCard>
                      <CCardBody>
                        <div className="text-danger tw-flex tw-justify-center">
                          <IoIosWarning
                            style={{
                              width: "5rem",
                              height: "5rem",
                            }}
                          />
                        </div>
                        <div
                          className="fw-semibold text-dark text-center"
                          style={{
                            fontSize: "1rem",
                            marginLeft: "10px",
                            marginRight: "10px",
                          }}
                        >
                          {text}
                        </div>
                      </CCardBody>
                      <CCardFooter align="right">
                        <CButton
                          className="mr-2"
                          color="secondary"
                          onClick={() => {
                            if (onCancel) onCancel();
                            closeWarning();
                          }}
                        >
                          Batal
                        </CButton>
                        <SubmitButton
                          color="warning"
                          text={isValidToContinue ? "Setuju" : `(${countdown})`}
                          onSubmit={() => {
                            if (isValidToContinue) {
                              //   func();
                              console.log("ok");
                              if (onConfirm) onConfirm();
                              closeWarning();
                            }
                          }}
                        />
                      </CCardFooter>
                    </CCard>
                  </div>
                </>
              ) : null}
            </>,
            element
          )
        : null}
    </>
  );
};
